// src/components/AdminPanel/AdminLoginForm.js
import React, { useState } from "react";
import { Form, Input, Button, Typography, message } from "antd";
import axios from "axios";
import "./AdminLoginForm.css";
import { BASE_URL } from "../../api/pharmacy";

const { Title } = Typography;

const AdminLoginForm = ({ onLoginSuccess }) => {
  const [loading, setLoading] = useState(false);

  const handleLogin = async ({ username, password }) => {
    setLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/pharmacy/admin/login`, {
        username,
        password,
      });
      if (response.data.success) {
        message.success("Login successful");
        onLoginSuccess(); // Show admin panel
      } else {
        message.error("Invalid credentials");
      }
    } catch (error) {
      message.error("Invalid credentials");
    }
    setLoading(false);
  };

  return (
    <div className="admin-login-container">
      <Title level={3}>Admin Login</Title>
      <Form layout="vertical" onFinish={handleLogin}>
        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: "Please enter username" }]}
        >
          <Input placeholder="Enter admin username" />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Please enter password" }]}
        >
          <Input.Password placeholder="Enter admin password" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>
            Login
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AdminLoginForm;